import domReady from '../utils/domReady';
import node from '../utils/node';


domReady.then(()=>{
    [...document.querySelectorAll('page-nav')].forEach((element) => {
        let attr = element.getAttribute('attr');
        node({
            element,
            nodes: [...element.parentNode.querySelectorAll(`${element.getAttribute('sel')}[${attr}]`)].map((targetEl)=>{
                return {
                    sel:'span',
                    content: targetEl.getAttribute(attr),
                    events: [
                        {on:'click',fn(e){window.scrollTo({top:targetEl.offsetTop - 150,behavior:'smooth'})}}
                    ]
                };
            })
        });
    });
});
